/**
 * Order two tree labels the way a person reads them.
 *
 * Labels are strings because crews renumber with suffixes — "12A" is inserted
 * after "12" on a map already printed and sitting in a truck. Plain string
 * comparison would then put "100" before "41" and "12A" before "2", so the
 * number is compared as a number and whatever follows breaks ties.
 *
 * A leading "#" is skipped rather than required: the real data writes labels
 * both ways, and a sort that only worked on one of them would look right on
 * every site until the first one that did not use it.
 */
export function compareTreeLabels(a: string, b: string): number {
  const parse = (label: string): [number, string] => {
    const match = /^\D*?(\d+)(.*)$/.exec(label.trim())
    if (match === null) return [Number.MAX_SAFE_INTEGER, label]
    return [Number(match[1]), match[2] ?? '']
  }
  const [aNumber, aRest] = parse(a)
  const [bNumber, bRest] = parse(b)
  if (aNumber !== bNumber) return aNumber - bNumber
  return aRest.localeCompare(bRest)
}
